import React, { useCallback } from "react";
import APP_ROUTES from "src/routes/routes";
import routeGuard from "src/HOC/routeGuard";
import { useParams, useSearchParams } from "react-router-dom";
import RocketModelDetail from "src/components/RocketModel/detail";
import { RESOURCE_TYPE } from "src/constant/common";

const RocketModel = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");

  const getRedirectURL = useCallback(() => 
    `${APP_ROUTES.ROCKET_MODEL}?id=${id}${page ? "&page=" + page : ""}`,
    [id, page]
  );

  return <RocketModelDetail getRedirectURL={getRedirectURL} />;
};

export default routeGuard(RocketModel, RESOURCE_TYPE.LABOR_SAVING);
